export default __webpack_public_path__ + "static/media/newsHonored.49d85802.png";